<template>
  <form @submit.prevent="onSubmit">
    <ValidationAlert :errors="errors" />
    <div class="row">
      <div class="col">
        <label class="font-weight-bold">Email</label>
        <div><input class="w-100" type="email" v-model="form.email" /></div>
      </div>
      <div class="col">
        <label class="font-weight-bold">Customer Id</label>
        <div>
          <input class="w-100" type="text" v-model="form.customer_id" />
        </div>
      </div>
      <div class="col">
        <label class="font-weight-bold">Subscription Id</label>
        <div>
          <input class="w-100" type="text" v-model="form.subscription_id" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col text-right pt-3">
        <button type="submit" class="btn btn-primary">Sync Subscription</button>
      </div>
    </div>
  </form>
</template>
<script>
import Vue from "vue";
import ValidationAlert from "@/components/Forms/ValidationAlert.vue";
export default {
  components: { ValidationAlert },
  props: {
    teamId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: {
        email: "",
        customer_id: "",
        subscription_id: ""
      },
      isPosting: false,
      errors: []
    };
  },
  methods: {
    async onSubmit() {
      this.errors = [];
      this.isPosting = true;
      await this.$http
        .post(
          `/enroll_admin/teams/${this.teamId}/sync-stripe-subscription`,
          this.form
        )
        .then(() => {
          Vue.$toast.success("Subscription synced with team!");
          this.clearForm();
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            this.errors = error.response.data;
          }
        })
        .finally(() => {
          this.isPosting = false;
        });
    },
    clearForm() {
      this.form = {
        email: "",
        customer_id: "",
        subscription_id: ""
      };
    }
  }
};
</script>
